import React from "react";

import { Box, Tooltip } from "@mui/material";

export function ColumnHeader({
  label,
  tooltip,
}: {
  label: string;
  tooltip: string;
}) {
  return (
    <Tooltip title={tooltip}>
      <Box fontWeight={600} fontSize="0.8125rem">
        {label}
      </Box>
    </Tooltip>
  );
}
